import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=1e087b3e&scoped=true"
import script from "./ServiceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ServiceCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=1e087b3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e087b3e",
  null
  
)

export default component.exports